import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { VERSION } from '@ideapa/app-common';
import { LoginResponseDto } from '@ideapa/common-dto';
import { MFAMethodEnum } from '@ideapa/common-utils';
import { AuthFacade } from '../../+state/auth.facade';
import { AuthService } from '../../auth.service';

@Component({
  standalone: false,
  templateUrl: './choose-mfa-method.container.html',
  styleUrls: ['./choose-mfa-method.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseMfaMethodContainer implements OnInit {
  loginResponse: LoginResponseDto | null = null;

  constructor(
    @Inject(VERSION) public version: string,
    private authFacade: AuthFacade,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.loginResponse = this.authService.getLoginResponse();
  }

  mfaMethodEnum = MFAMethodEnum;

  selectMfaMethod(method: MFAMethodEnum) {
    if (this.loginResponse) {
      this.authFacade.proceedToMFAMethod(method, this.loginResponse);
    } else {
      this.authFacade.missingLoginResponse();
    }
  }
}
